import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const Challenge = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      duration: 800,
      easing: 'ease-out'
    });
  }, []);

  return (
    <section className="lg:py-16 lg:px-12 px-4 py-12 bg-bgDefault text-white overflow-x-hidden">
      <div className="container mx-auto w-full max-w-full max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            data-aos="fade-down"
          >
            The Challenge
          </h2>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Medical education institutions faced a critical challenge: students were entering clinical rotations
            without adequate hands-on experience with Electronic Health Record systems, leading to costly mistakes
            and extended training periods in real healthcare environments. Traditional paper-based training methods
            couldn't replicate the complexity of modern EHR workflows, and using live production systems posed
            unacceptable risks to patient data privacy and safety.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            Key Challenges:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-8 lg:mb-12 list-disc pl-5 space-y-2">
            <li data-aos="fade-left" data-aos-delay="250">Need for realistic simulation of complex EHR workflows including patient charts, lab orders, prescriptions, and medical histories</li>
            <li data-aos="fade-left" data-aos-delay="300">Safe environment for students to practice and make mistakes without risking actual patient data</li>
            <li data-aos="fade-left" data-aos-delay="350">Platform for conducting practical examinations with structured faculty feedback mechanisms</li>
            <li data-aos="fade-left" data-aos-delay="400">HIPAA and FERPA compliance requirements for educational healthcare data</li>
            <li data-aos="fade-left" data-aos-delay="450">Scalability to serve thousands of medical students across multiple institutions simultaneously</li>
            <li data-aos="fade-left" data-aos-delay="500">Integration with diverse academic curricula and examination processes</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Challenge
